import React from 'react';
import ReactDOM from 'react-dom/client';
import 'keen-slider/keen-slider.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import allReducers from './store';
import { ToastContainer } from 'react-toastify';
import { BrowserRouter } from 'react-router-dom';
import './utils/i18n';

import '@adobe/adobe-client-data-layer';

// 🔐 Datadog RUM Setup
import { datadogRum } from '@datadog/browser-rum';
// import { reactPlugin } from '@datadog/browser-rum-react';

datadogRum.init({
  applicationId: process.env.REACT_APP_DD_APPLICATION_ID,
  clientToken: process.env.REACT_APP_DD_CLIENT_TOKEN,
  site: process.env.REACT_APP_DD_SITE,
  service: process.env.REACT_APP_DD_SERVICE,
  env: process.env.REACT_APP_DD_ENV,
  version: process.env.REACT_APP_DD_VERSION,
  sessionSampleRate: Number(process.env.REACT_APP_DD_SESSION_SAMPLE_RATE),
  sessionReplaySampleRate: Number(process.env.REACT_APP_DD_SESSION_REPLAY_SAMPLE_RATE),
  defaultPrivacyLevel: process.env.REACT_APP_DD_DEFAULT_PRIVACY_LEVEL,
});
// ✅ END Datadog Setup

const store = configureStore({
    reducer: allReducers,
});

window.adobeDataLayer = window.adobeDataLayer || [];

async function fetchCmsRoutes() {
    try {
        const response = await fetch('https://matwproject.org/backend/index.php/api/routes?route_type=builder');
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        localStorage.setItem('storedCmsRoutes', JSON.stringify(data));
        localStorage.setItem('storedTimestamp', Date.now().toString());
    } catch (error) {
        console.error('Failed to fetch builder routes:', error);
    }
}

function initializeApp() {
    fetchCmsRoutes().then(() => {
        const root = ReactDOM.createRoot(document.getElementById('root'));
        root.render(
            <Provider store={store}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
                <ToastContainer position="bottom-right" bodyClassName={'text-sm font-roboto'} />
            </Provider>
        );
    });
}

// Run app
initializeApp();

reportWebVitals();
